<template>
  <div
    role="group"
    aria-roledescription="slide"
    class="tw-min-w-0 tw-shrink-0 tw-grow-0 tw-basis-full tw-pl-4"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'CarouselItem',
}
</script>
